import React from "react"
import Img from "gatsby-image"
import { Link } from "gatsby"

const Treatment = ({ treatment }) => {
  return (
    <React.Fragment>
      <div className="mx-0 px-0 card text-white">
        <Link className="text-white" to={`/treatment/${treatment.slug}`}>
          <Img
            fadeIn
            style={{
              minHeight: "21rem",
              minWidth: "100%",
              objectFit: "cover",
              filter: "brightness(75%)",
            }}
            fluid={treatment.featured_media.localFile.childImageSharp.fluid}
            className="card-img"
            alt={treatment.featured_media.alt_text}
          />
          <div className="card-img-overlay d-flex align-items-center justify-content-center flex-column">
            <h5 className="card-title text-center">{treatment.title}</h5>
            <button type="button" className="btn btn-outline-light">
              Baca lebih lanjut
            </button>
          </div>
        </Link>
      </div>
    </React.Fragment>
  )
}

export default Treatment
